
define('jsx!components/login-private-tenant/divider-or',["react"], function (React) {
	return React.createClass({
		render: function () {
			return (
				React.createElement("div", {className: "horizon-line"}, 
					React.createElement("span", {key: "line-1", className: "horizon-line-half"}), 
					React.createElement("span", {key: "or", className: "horizon-line-text"}, "or"), 
					React.createElement("span", {key: "line-2", className: "horizon-line-half"})
				)
			);
		}
	});
});
